import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { StudyOnboarding } from "@/components/study/StudyOnboarding";
import { nextWave, useStudyStore } from "@/lib/stores/studyStore";
import { useAuthStore } from "@/lib/stores/authStore";

const searchSchema = z.object({
  step: z.enum(["info", "consent"]).catch("info"),
});

export const Route = createFileRoute("/(content)/study/")({
  component: StudyIndexComponent,
  validateSearch: searchSchema,
  head: () => ({ meta: [{ title: "Study - HAMD" }] }),
  beforeLoad: () => ({
    title: "study.info.title",
    navbar: { showTitle: true },
  }),
});

function StudyIndexComponent() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const status = useStudyStore((s) => s.status);
  const hasFetched = useStudyStore((s) => s.hasFetched);
  const { step } = Route.useSearch();

  useEffect(() => {
    if (!user) return;
    if (!hasFetched) return;
    if (!status) return;
    const wave = nextWave(status);
    if (wave) {
      navigate({ to: "/study/$wave", params: { wave: wave.toLowerCase() as "t0" | "t1" | "t2" } });
    } else {
      navigate({ to: "/study/done", search: { wave: "T2" } });
    }
  }, [user, status, hasFetched, navigate]);

  return (
    <StudyOnboarding
      isGuest={!user}
      step={step}
      onStepChange={(s) => navigate({ to: "/study/", search: { step: s } })}
    />
  );
}
